import React from "react";

export default () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12 20C12.55 20 13 19.5 13 19V5.00007C13 4.5 12.55 4 12 4C11.45 4 11 4.50007 11 5.00007V19C11 19.5 11.45 20 12 20ZM6 20C6.55 20 7 19.5 7 19V13.0001C7 12.5001 6.55 12 6 12C5.45 12 5 12.5 5 13.0001V19C5 19.5 5.45 20 6 20ZM17 19V10.0001C17 9.5 17.45 9 18 9C18.55 9 19 9.50007 19 10.0001V19C19 19.5 18.55 20 18 20C17.45 20 17 19.5 17 19Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
